<template>
    <div>
        <div class="accordion-container" :class="isClosed ? '' : 'show-less'">
            <div class="accordion-header" @click="handleClosed">
                <img class="gift-icon" src="/images/fr_new_home/Atom/Icon/gift-icon-recap.png" alt="gift icon">
                <div>
                    <h2 class="pack-pretitle">VOTRE PACK</h2>
                    <h3 class="pack-title">Vous bénéficiez de l’offre
                        à 2€/2 mois + votre cadeau de bienvenue au choix</h3>
                </div>
                <span :class="['accordion-btn', 'show-more', { 'is-open': !isClosed }]"></span>
            </div>
        </div>
        <div class="form-pack">
            <div :class="isClosed ? 'is-closed' : ''" class="accordion-body">
                <ul class="pack-list">
                    <li>
                        <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">
                        <div>
                            <img class="pack-img" :src="form_side_image">
                            <strong>Votre cadeau de bienvenue parmi + 150 choix</strong>
                        </div>
                    </li>
                    <li>
                        <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">Vos magazines
                        en
                        version papier et numérique
                    </li>
                    <li>
                        <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">Une assistance
                        juridique, fiscale et technique illimitée
                    </li>
                    <li>
                        <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">12 guides
                        pratiques
                        au
                        choix
                    </li>
                </ul>
                <!--            <div class="pack-illu">-->
                <!--                <div>-->
                <!--                    <img src="/images/new_branding/pack-garantie.png">-->
                <!--                    <p>La Garantie Sérénité de Testachats</p>-->
                <!--                </div>-->
                <!--                <p class="text">Vous restez libre d'interrompre votre abonnement à tout moment.</p>-->
                <!--            </div>-->
            </div>
        </div>
    </div>

</template>

<script>
import image_mixin from "./mixins/image_mixin";

export default {
    name: "PackComponentAccordion",
    mixins: [
        image_mixin
    ],
    computed: {
        isIban() {
            return this.$store.get('general_data/current_step') === 'iban'
        }
    },
    data() {
        return {
            isClosed: true,
        };
    },
    methods: {
        handleClosed() {
            this.isClosed = !this.isClosed;
        },
    },
    mounted() {
        // console.log('test store',(this.$store.get('general_data/current_step' === 'iban')))

    }
}
</script>

<style lang="scss" scoped>

</style>
